// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddFiltersPopupActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

import { curry, forEach, get } from 'lodash/fp';
import { withHandlers, compose, withProps } from 'recompose';
import { action } from 'mobx';

export default compose(
  withProps(() => ({
    popupFields: {
      selectedData: []
    }
  })),
  withHandlers({
    closed: curry(closed),
    onChangeSeletedField: curry(onChangeSeletedField)
  })
);

async function closed(props: any, closeFunc: any, type: any) {
  let {
    popupFields: { selectedData }
  } = props;
  if (type === 'cancel') {
    props.onReject();
  } else {
    let defaultData = {
      sourceFieldVisible: true,
      sourceFieldFilterable: true
    };
    const {
      store: {
        reportFilters: { addFilter },
        reportFilters
      }
    } = props;

    const setNewFilterDetails = action((fieldDetails: any) => {
      if (fieldDetails && !fieldDetails.operatorId && reportFilters) {
        reportFilters.loadDefaultOperator(fieldDetails);
      }
      reportFilters.newestFilter.setFilterDetails(fieldDetails || {}, true);
      reportFilters.disableCascading();
      return true;
    });
    forEach(function(item) {
      const filterDetails = get('filterDetails', item);
      addFilter.call(reportFilters, defaultData);
      setNewFilterDetails(filterDetails);
    }, selectedData);
    props.onAccept();
  }
}

function onChangeSeletedField(props: any, data: any) {
  props.popupFields.selectedData = data;
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.AddFiltersPopupActions.js